import { render, staticRenderFns } from "./AddItemTypeModal.vue?vue&type=template&id=3757875a&scoped=true&class=fill-height&"
import script from "./AddItemTypeModal.vue?vue&type=script&lang=ts&"
export * from "./AddItemTypeModal.vue?vue&type=script&lang=ts&"
import style0 from "./AddItemTypeModal.vue?vue&type=style&index=0&id=3757875a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3757875a",
  null
  
)

export default component.exports